module.exports = __webpack_public_path__ + "static/media/busy.5715447e.png";